export default "__VITE_ASSET__031fc67a__"